import { useMemo, useRef } from "react";

export const useSearch = <T>(items: T[], getFields: (item: T) => string[], search: string | null) => {
    const getFieldsRef = useRef(getFields);

    return useMemo(() => {
        if (!search) {
            return items;
        }

        return items.filter((item) => {
            return getFieldsRef.current(item).some((field) => field?.toLowerCase().includes(search.toLowerCase()));
        });
    }, [items, search, getFieldsRef]);
};

/**
 * Case-insensitive way to check if needle is present in the haystack i.e. one string contains another
 *
 * @param needle
 * @param haystack
 */
export const stringIncludes = (needle: string, haystack: string) => {
    return haystack.toLocaleLowerCase().includes(needle.trim().toLocaleLowerCase());
};
